module.exports = __webpack_public_path__ + "img/lonstar-member.21d9adf5.svg";